import request from '../../utils/request';

export const plantService = {
    //工厂列表数据查询
    getPlantData: (data) => {
        return request({
            url: '/plant/list',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //修改工厂提货点
    updatePlantPickupPoint: (data) => {
        return request({
            url: '/plant/pickupPoint',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    listUsers:(plantId)=>{
        return  request({
            url:`/plant/${plantId}/sensoryUsers`,
            method: 'get'
        })
    },
    saveSensoryPlantUsers:(plantId,users)=>{
        return  request({
            url:`/plant/${plantId}/sensoryUsers`,
            method: 'POST',
            data:{
                users: users
            }
        })
    }
}
